import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { DiarioOcorrenciasForm } from "../../modais"

class DiarioOcorrenciasCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/diarioocorrencias")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <DiarioOcorrenciasForm callBackDiarioDeOcorrencia={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(DiarioOcorrenciasCreateForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/diario-ocorrencias/DiarioOcorrenciasCreateForm.js